import React from "react"
import PropTypes from "prop-types"

import { verifyIntendedPromiseRejection } from "./utils/modal_promise"

import "./diy_add_tanda_button.scss"

export default function DIYAddFilterQueryButtons({
  anyActionAdded,
  filterButtonDisabled,
  onFilterButtonClick,
  onQueryButtonClick,
}) {
  const filterCopy = () => {
    if (anyActionAdded) {
      return "Filter your result set."
    } else {
      return "Before adding filter code, add an action."
    }
  }

  return (
    <section styleName="add-new-query-filter">
      <div styleName="add-query">
        <button
          className="button-tertiary"
          onClick={verifyIntendedPromiseRejection(onQueryButtonClick)}
        >
          Add query
        </button>
        <span>Query a subset of data</span>
      </div>
      <div styleName="add-filter">
        <button
          className="button-tertiary"
          onClick={verifyIntendedPromiseRejection(onFilterButtonClick)}
          disabled={filterButtonDisabled || !anyActionAdded}
        >
          Add filter
        </button>
        <span>{filterCopy()}</span>
      </div>
    </section>
  )
}

DIYAddFilterQueryButtons.propTypes = {
  onQueryButtonClick: PropTypes.func.isRequired,
  onFilterButtonClick: PropTypes.func.isRequired,
  filterButtonDisabled: PropTypes.bool,
  anyActionAdded: PropTypes.bool,
}

DIYAddFilterQueryButtons.defaultProps = {
  filterButtonDisabled: false,
}
